import { FormattedMessage, useIntl } from 'react-intl';
import { Fade, Stack } from '@mui/material';
import { FilterMultiSelect, SearchField, renderCheckboxOption } from '@atoms/inputs';
import { Box, Flex } from '@atoms/layout';
import { Button } from '@atoms/buttons';
import { FaIcon } from '@atoms/icons';
import { ActiveFilters } from '@molecules/dataDisplay';
import { FilterItem } from '@molecules/dataDisplay/activeFilters';
import { useAgencyTypesListFilterStore } from '@libs/store/agencyTypes/listFiltersStore';

type ShiftsFiltersProps = {
  loading: boolean;
  localizationSubset: string;
};
export function AgencyTypesFilters({ loading, localizationSubset }: ShiftsFiltersProps) {
  const intl = useIntl();
  const { activeFilters, clearFilter, clearFilters, getFilter, setFilterFromOptions, setFilter } =
    useAgencyTypesListFilterStore();

  return (
    <Stack direction={'column'} spacing={1}>
      <Flex justifyContent="space-between" gap={2}>
        <Flex gap={2} flexWrap="wrap">
          <Fade in={activeFilters.length > 0} timeout={150}>
            <Button
              variant="passive"
              onClick={() => clearFilters()}
              startIcon={<FaIcon name="xmark" />}
              sx={{ ml: 'auto' }}
            >
              <FormattedMessage id="common.clearAllFilters" />
            </Button>
          </Fade>
        </Flex>
        <SearchField
          sx={{ width: 260, flexShrink: 0 }}
          value={getFilter<string>('search')?.value ?? ''}
          onChange={(elem: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
            elem.target.value ? setFilter({ key: 'search', value: elem.target.value }) : clearFilter('search')
          }
        />
      </Flex>
      <Stack direction={'row'} spacing={2}>
        <ActiveFilters
          filters={activeFilters.reduce((acc, f) => {
            if (f.key === 'locations') {
              return acc;
            }
            acc.push({
              ...f,
              label: <FormattedMessage id={`${localizationSubset}.filters.${f.key}.label`} />,
            });
            return acc;
          }, [] as FilterItem[])}
          onDelete={(item) => clearFilter(item.key)}
        />
      </Stack>
    </Stack>
  );
}
